import React, {useEffect, useState} from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
    getTokenCourse, setBuyRequest,
    // sendWalletAfterTransaction,
    setMatrixBuyModalStatus,
    setMatrixBuyQrModalStatus
} from "../../store/cabinet/action";
import cfpIcon from "../../theme/assets/other/ftf_cft_icon2.png";
import tonIcon from "../../theme/assets/other/ftf_ton_icon.png";
import modalArrow from '../../theme/assets/svg/ftf_modal_arrow.svg';
import usdtIcon from '../../theme/assets/svg/ftf_modal_usdt_icon.svg';
// import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";
// import { useNavigate } from "react-router-dom";
// import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";




const CabinetMatrixBuyModal = () => {
    const dispatch = useDispatch();
    // const navigate = useNavigate();
    // const userFriendlyAddress = useTonAddress();
    // const [tonConnectUI] = useTonConnectUI();
    const { t } = useTranslation();

    const matrixBuyModalStatus = useSelector((store) => store.cabinet.matrixBuyModalStatus);
    const userData = useSelector(store => store.cabinet.userData);

    const [amount, setAmount] = useState("");
    const [currentCurrency, setCurrentCurrency] = useState('TON');
    const [dropdownStatus, setDropdownStatus] = useState(false);

    const handleChange = (e) => {
        let newValue = e.target.value;
        // Разрешаем только цифры (точку вводим не разрешая)
        newValue = newValue.replace(/[^0-9]/g, "");
        const num = parseFloat(newValue);
        if (!isNaN(num)) {
            newValue = (Math.round(num * 100) / 100).toString();
        }
        setAmount(newValue);
    };

    // Функция форматирования значения до 2 знаков с удалением лишних нулей
    // const formatValue = (value) => {
    //     if (isNaN(value)) return "";
    //     const rounded = Math.round(value * 100) / 100;
    //     return parseFloat(rounded.toFixed(2)).toString();
    // };

    const closeModal = () => {
        dispatch(setMatrixBuyModalStatus(false));
    };

    // const settingsHandler = () => {
    //     navigate("/settings");
    //     closeModal();
    // };

    // const transactionHandler = async () => {
    //     if (userFriendlyAddress && amount > 0 && tokenRate) {
    //         console.log(formatValue(Number(amount) * Number(tokenRate?.token_rate)), formatValue(Number(amount) * Number(tokenRate?.token_rate)) * 1000000000)
    //         const myTransaction = {
    //             validUntil: Math.floor(Date.now() / 1000) + 60, // 60 сек
    //             messages: [
    //                 {
    //                     address: "UQChxNSMZjJ-PwzQOsom5XdoxxbhdqYtLNHGMQU7oWuBJecK",
    //                     amount: `${formatValue(Number(amount) * Number(tokenRate?.token_rate)) * 1000000000}`,
    //                     // stateInit: "base64bocblahblahblah==" // при необходимости
    //                 },
    //             ],
    //         };
    //
    //         try {
    //             const result = await tonConnectUI.sendTransaction(myTransaction);
    //             dispatch(sendWalletAfterTransaction(userFriendlyAddress))
    //             toast('Your funds have been sent successfully. Wait for the tokens!');
    //             closeModal();
    //             console.log("Общий результат транзакции:", result);
    //             console.log("BOC транзакции:", result.boc);
    //         } catch (error) {
    //             if (error.message.includes("User rejected")) {
    //                 console.log("Пользователь отменил подтверждение транзакции");
    //             } else {
    //                 console.error("Ошибка при отправке транзакции:", error);
    //             }
    //         }
    //     }
    // };

    useEffect(() => {
        if (matrixBuyModalStatus){
            dispatch(getTokenCourse());
        }
    }, [dispatch, matrixBuyModalStatus]);

    return (
        <Popup
            open={matrixBuyModalStatus}
            modal
            nested
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={`${Styles.modalContainer}`}>
                <div
                    className={`${Styles.modalCloseBtn}`}
                    onClick={() => {
                        closeModal();
                    }}
                >
                    <div />
                    <div />
                </div>
                <div className={`${Styles.modalContentWrap}`}>
                    <div className={`${Styles.modalTitle}`}>{t('Купить токены')}</div>
                    <div className={`${Styles.inputsPosWrap}`}>
                        <div className={`${Styles.inputWrap}`}>
                            <div className={`${Styles.inputTitle}`}>
                                {t('Введите количество токенов, которые вы хотите купить')}:
                            </div>
                            <div className={`${Styles.inputWrapAbsCurrencyWI}`}>
                                {t('Токены')}
                            </div>
                            <div className={`${Styles.inputWrapAbsIconWI}`}>
                                <img src={cfpIcon} alt="CFP" />
                            </div>
                            <input
                                type="text"
                                className={`${Styles.ftfBorderInput}`}
                                value={amount}
                                onChange={handleChange}
                            />
                            <div className={`${Styles.inputDataRow}`}>
                                <div className={`${Styles.balance}`}>
                                    {t('Доступно токенов')}: {userData?.user?.coins ? userData.user.coins * 1 : '0'}
                                </div>
                                {/*<div className={`${Styles.course}`}>*/}
                                {/*    {t('Курс')}: {tokenRate ? `1 CFP = ${tokenRate?.token_rate} TON` : 'Loading...'}*/}
                                {/*</div>*/}
                            </div>
                        </div>
                        <div className={`${Styles.inputWrap}`}>
                            <div className={`${Styles.inputTitle}`}>
                                {t('Выберите валюту в которой хотите оплатить')}:
                            </div>
                            <div className={`${Styles.fakeInput} ${Styles.ftfBorderInput}`}>
                                <div className={`${Styles.inputWrapAbsCurrency}`} onClick={()=>{setDropdownStatus(!dropdownStatus)}}>
                                    <img src={modalArrow} alt="dropdown"/>
                                </div>
                                <div className={`${Styles.inputWrapAbsIcon}`}>
                                    <img src={currentCurrency === 'TON' ? tonIcon : usdtIcon} alt="current currency" />
                                    <div className={`${Styles.inputWrapAbsIconCurrency}`}>{currentCurrency}</div>
                                </div>
                            </div>
                            <div className={`${Styles.inputWrapDropdown} ${dropdownStatus ? Styles.inputWrapDropdownActive : null}`}>
                                <div
                                    className={`${Styles.inputWrapDropdownItem} ${currentCurrency === 'TON' ? Styles.inputWrapDropdownItemActive : null}`}
                                    onClick={()=>{
                                        setCurrentCurrency('TON');
                                        setDropdownStatus(false);
                                    }}
                                >
                                    <div className={`${Styles.inputWrapDropdownItemImgWrap}`}>
                                        <img src={tonIcon} alt="ton"/>
                                    </div>
                                    <div className={`${Styles.inputWrapDropdownItemCurrency}`}>TON</div>
                                </div>
                                <div
                                    className={`${Styles.inputWrapDropdownItem} ${currentCurrency === 'USDT' ? Styles.inputWrapDropdownItemActive : null}`}
                                    onClick={()=>{
                                        setCurrentCurrency('USDT');
                                        setDropdownStatus(false);
                                    }}
                                >
                                    <div className={`${Styles.inputWrapDropdownItemImgWrap}`}>
                                        <img src={usdtIcon} alt="usdt"/>
                                    </div>
                                    <div className={`${Styles.inputWrapDropdownItemCurrency}`}>USDT</div>
                                </div>
                            </div>
                            <div className={`${Styles.inputDataRow}`}>
                                {/*<div className={`${Styles.commission}`}>{t('Комиссия')}: 0.1 TON</div>*/}
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.btnsWrap}`}>
                        <div
                            className={`${amount > 0 ? Styles.ftfBorderBtn : Styles.ftfDisabledBtn}`}
                            onClick={()=>{
                                if (amount > 0){
                                    dispatch(setBuyRequest(currentCurrency, {amount: amount}))
                                    closeModal();
                                    dispatch(setMatrixBuyQrModalStatus(true));
                                }
                            }}
                        >
                            {t('Подтвердить')}
                        </div>
                    </div>
                    {/*<div className={`${Styles.btnsWrap}`}>*/}
                    {/*    <div*/}
                    {/*        className={`${*/}
                    {/*            userFriendlyAddress && amount > 0 && tokenRate*/}
                    {/*                ? Styles.ftfBorderBtn*/}
                    {/*                : Styles.ftfDisabledBtn*/}
                    {/*        }`}*/}
                    {/*        onClick={transactionHandler}*/}
                    {/*    >*/}
                    {/*        {t('Купить через TG')} (TON)*/}
                    {/*    </div>*/}
                    {/*    <div*/}
                    {/*        className={`${Styles.ftfBorderBtn}`}*/}
                    {/*        onClick={()=>{*/}
                    {/*            closeModal();*/}
                    {/*            dispatch(setMatrixBuyQrModalStatus(true));*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        {t('Прямой платеж')} (USDT)*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*{!userFriendlyAddress ? (*/}
                    {/*    <div className={`${Styles.buyNote}`}>*/}
                    {/*        {t('Ваш телеграм кошелёк не подключён')}!{" "}*/}
                    {/*        <span onClick={settingsHandler}>{t('Настройки')}</span>*/}
                    {/*    </div>*/}
                    {/*) : null}*/}
                </div>
            </div>
        </Popup>
    );
};

export default CabinetMatrixBuyModal;
